module.exports = __webpack_public_path__ + "img/lg.4e101e50.jpg";